import { Store } from 'redux';

import { getInitialSearchLocation } from 'algolia-api/search/getInitialSearchLocation';
import { ApiUserEnvironment } from 'api/userEnvironment/types/ApiUserEnvironment';
import { MainStoreState } from 'modules/main/store/MainStoreState';
import { updateSearchLocation } from 'modules/main/store/ducks/mainSearch.actions';
import { updateUserEnvironment } from 'modules/main/store/ducks/userEnvironment.actions';
import { StaffStoreState } from 'modules/staff/store/StaffStoreState';
import { configureAnalyticsUserData } from 'utils/analytics/setup/configureAnalyticsUserData';
import { registerAbExperiments } from 'utils/analytics/setup/registerAbExperiments';
import { configureTrackJs } from 'utils/configureTrackJs';
import { trackReferrals } from 'utils/trackReferral';

import { renderingClientPerformanceMark } from './renderingClientPerformanceMark';
import { renderingOverrideClientABExperiments } from './renderingOverrideClientABExperiments';

type Args = {
  store: Store<MainStoreState | StaffStoreState>;
  userEnvironment: ApiUserEnvironment;
};

export function onRenderingClientUserEnvironmentLoaded({
  store,
  userEnvironment,
}: Args) {
  store.dispatch(updateUserEnvironment(userEnvironment));

  const { searchLocation } = store.getState().mainSearch;

  if (!searchLocation) {
    store.dispatch(
      // @ts-expect-error fix types
      updateSearchLocation(
        getInitialSearchLocation(userEnvironment.environment.guessedLocation),
        false,
      ),
    );
  }

  renderingClientPerformanceMark('Done setting login state');

  // Tracking
  configureTrackJs(userEnvironment.user ? userEnvironment.user.id : null);
  configureAnalyticsUserData({ userEnvironment });
  trackReferrals();

  // Configure AB experiments
  store.subscribe(() => {
    registerAbExperiments(
      store.getState().userEnvironment?.environment?.abExperiments,
    );
  });

  renderingOverrideClientABExperiments(store, userEnvironment);
  renderingClientPerformanceMark('User data first load');
}
